<nav class="flex flex-col items-center flex-1 gap-3 sm:gap-4 sm:flex-row mt-9">
	<a
		routerLink="/courses/degrees"
		class="flex items-center w-full h-full sm:w-auto focus:outline-none white-header-btn btn-py-2"
	>
		<uc-search-svg customStyles="mr-3" />
		Search Degrees
	</a>
	<a
		routerLink="/universities/undergraduate"
		class="flex items-center w-full h-full sm:w-auto focus:outline-none white-header-btn btn-py-2"
	>
		<uc-search-svg customStyles="mr-3" />
		Search Universities
	</a>
</nav>
